<!DOCTYPE html>
<html lang="tr">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">

<title>Bütün İşler — Moda Fotoğrafçılığı Arşivi | Frawgraphy</title>
<meta name="description" content="Frawgraphy stüdyosunun editoryal, kampanya, lookbook ve güzellik çekimlerinden oluşan arşiv seçkisi.">
<meta name="robots" content="index, follow, max-image-preview:large">
<link rel="canonical" href="https://frawgraphy.com/works.html">

<meta property="og:type" content="website">
<meta property="og:site_name" content="Frawgraphy">
<meta property="og:locale" content="tr_TR">
<meta property="og:url" content="https://frawgraphy.com/works.html">
<meta property="og:title" content="Bütün İşler — Frawgraphy Arşivi">
<meta property="og:description" content="Editoryal, kampanya ve güzellik çekimlerinden arşiv seçkisi.">
<meta property="og:image" content="https://frawgraphy.com/assets/img/work-1-900.jpg">
<meta name="twitter:card" content="summary_large_image">

<link rel="icon" href="/favicon.ico" sizes="any">
<link rel="icon" type="image/png" sizes="32x32" href="/assets/img/favicon-32.png">
<link rel="icon" type="image/png" sizes="16x16" href="/assets/img/favicon-16.png">
<link rel="apple-touch-icon" sizes="180x180" href="/assets/img/apple-touch-icon.png">
<link rel="manifest" href="/site.webmanifest">

<meta name="theme-color" content="#060606" media="(prefers-color-scheme: dark)">
<meta name="theme-color" content="#f5f3f0" media="(prefers-color-scheme: light)">

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;0,6..96,700;0,6..96,900;1,6..96,400;1,6..96,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500&display=swap">
<link rel="stylesheet" href="assets/css/style.css?v=20260920b">
<noscript><style>.reveal{opacity:1;transform:none}</style></noscript>

<script>
  (function () {
    try {
      var t = localStorage.getItem('frawgraphy-theme');
      if (!t) t = matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', t);
      document.documentElement.setAttribute('data-lang', localStorage.getItem('frawgraphy-lang') || 'tr');
    } catch (e) {
      document.documentElement.setAttribute('data-theme', 'dark');
      document.documentElement.setAttribute('data-lang', 'tr');
    }
  })();
</script>
</head>
<body data-title-key="works.docTitle">

<a class="skip-link" href="#main" data-i18n="skip">İçeriğe geç</a>

{{> header }}

{{> menu }}

<main id="main" class="page">
  <div class="shell">

    <nav class="crumbs" aria-label="Site yolu">
      <ol>
        <li><a href="index.html" data-i18n="blog.crumbHome">Ana sayfa</a></li>
        <li aria-current="page" data-i18n="works.crumb">Bütün işler</li>
      </ol>
    </nav>

{{{ pageHead }}}

    <ul class="works-grid" data-digital>
{{#each works}}
{{#if albumSlug}}
      <li class="works-item works-item--album reveal" style="--r:{{ r }};--s:{{ s }}">
        <a href="{{ base }}album-{{ albumSlug }}.html" aria-label="{{ album.aria }}"
           data-i18n-attr="aria-label:works.album.aria">
          <img src="{{ browse }}" alt="{{ alt }}" width="{{ photo.width }}" height="{{ photo.height }}" loading="lazy" decoding="async">
          <span class="works-album-badge">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 4h12v12M4 8h12v12H4z"/></svg>
            <span data-i18n="works.album.tag">Albüm</span>
            <span class="works-album-count">{{ album.count }}</span>
          </span>
          <span class="works-meta">
            <span class="works-cat" data-i18n="works.album.name">{{ album.title }}</span>
            <span class="works-year" data-i18n="works.album.count">{{ album.countLabel }}</span>
          </span>
        </a>
      </li>
{{^}}
      <li class="works-item reveal" style="--r:{{ r }};--s:{{ s }}">
        <a href="{{ full }}" data-digital-hit aria-label="{{ zoomAria }}">
          <img src="{{ browse }}" alt="{{ alt }}" width="{{ photo.width }}" height="{{ photo.height }}" loading="lazy" decoding="async">
          <span class="works-meta">
            <span class="works-cat">{{ category }}</span>
            <span class="works-year">{{ year }}</span>
          </span>
        </a>
      </li>
{{/if}}
{{/each}}
    </ul>

      {{> lightbox }}

    <aside class="page-cta reveal">
      <h2 data-i18n="works.cta.title">Sıradaki seri sizin olabilir</h2>
      <p data-i18n="works.cta.text">Takvimimiz iki ay önceden dolar. Tarih ve kapsamı yazmanız yeterli.</p>
      <a class="btn btn--primary" href="index.html#contact">
        <span data-i18n="blog.cta.btn">Çekim planla</span>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </a>
    </aside>
  </div>
</main>

{{> footer }}

<script src="assets/js/i18n.js?v=20260920b" defer></script>
<script src="assets/js/main.js?v=20260920b" defer></script>
</body>
</html>
